import type { AppType } from '=/types'

import { api } from '../services/api'
import { session } from '../services/session'

const SESSION_KEY = '__textures_app__'

export async function getApp(): Promise<AppType> {
  const cached = session.get<AppType>(SESSION_KEY)

  if (cached) {
    setApp(cached)
    return cached
  }

  const type = await api.get<AppType>('app')
  setApp(type)

  session.set(SESSION_KEY, type)

  return type
}

function setApp(app: AppType) {
  document.body.classList.add(app.class)

  try {
    if (app.name) {
      document.title = app.name
    }

    const head = document.head || document.getElementsByTagName('head')[0]

    if (!head) return

    const faviconPng = head.querySelector<HTMLLinkElement>('link[rel="icon"][type="image/png"]')
    const faviconSvg = head.querySelector<HTMLLinkElement>('link[rel="icon"][type="image/svg+xml"]')
    const appleTouchIcon = head.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]')
    const shortcutIcon = head.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]')
    const manifest = head.querySelector<HTMLLinkElement>('link[rel="manifest"]')

    const base = `${import.meta.env.VITE_BACKEND_URL}assets/${app.class}/`

    if (faviconPng) faviconPng.href = `${base}favicon-96x96.png`
    if (faviconSvg) faviconSvg.href = `${base}favicon.svg`
    if (appleTouchIcon) appleTouchIcon.href = `${base}apple-touch-icon.png`
    if (shortcutIcon) shortcutIcon.href = `${base}favicon.ico`
    if (manifest) manifest.href = `${base}site.webmanifest`
  } catch {
    // ignore
  }
}
